import React from "react";
import { HiOutlineSparkles } from "react-icons/hi";
import { VERTEX360_COPILOT_FLOATING_TOOLTIP } from "../constants/vertex360CopilotFloatingConstants";

const Vertex360CopilotTooltip = () => (
  <div className="copilot-floating-tooltip">
    <div className="copilot-floating-tooltip__accent" aria-hidden="true" />

    <div className="copilot-floating-tooltip__header">
      <span className="copilot-floating-tooltip__icon" aria-hidden="true">
        <HiOutlineSparkles className="h-3.5 w-3.5" />
      </span>
      <div className="copilot-floating-tooltip__heading">
        <span className="copilot-floating-tooltip__title">
          {VERTEX360_COPILOT_FLOATING_TOOLTIP.title}
        </span>
        <span className="copilot-floating-tooltip__divider" aria-hidden="true">
          ·
        </span>
        {/* <span className="copilot-floating-tooltip__badge">Vertex360 Copilot</span> */}
      </div>
    </div>

    <p className="copilot-floating-tooltip__description">
      {VERTEX360_COPILOT_FLOATING_TOOLTIP.description}
    </p>
  </div>
);

export default Vertex360CopilotTooltip;
